module.exports = "<div class=intro-screen__contents> <img ng-if=\"$ctrl.options.assets.length && $ctrl.activeImage === 0\" ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.assets[0]}}> <img ng-if=\"$ctrl.options.assets.length && $ctrl.activeImage === 1\" ng-src={{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.assets[1]}}> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/intro-screen/intro-screen.html
 ** module id = 82
 ** module chunks = 0
 **/